/*
 * @deprecated Please use `src/common/styles/constants.ts::Breakpoint`
 */
export enum BookingFormBreakPoints {
  SMALL_MAX = 767,
  MEDIUM_MIN = 768,
  MEDIUM_MAX = 979,
  LARGE_MIN = 980,
  LARGE_MAX = 1199,
  X_LARGE_MIN = 1200,
}
